<template>
<section ref="section" id="programm" class="no-pad">
  <h1 class="no-pad" v-html="programm.title"></h1>
  <div ref="fragen" class="aha-row pre-programme">
    <p v-html="programm.friday_text"></p>
    <div ref="fragens" class="ahafrage">
    </div>
  </div>
  <div ref="fragen" class="aha-row pre-programme pad-bottom">
    <p v-html="programm.saturday_text"></p>
    <div ref="fragens" class="ahafrage">
    </div>
  </div>
  <h1 class="pad-day" v-if="this.$route.name !== 'english'">Freitag</h1>
  <h1 class="pad-day" v-else>Friday</h1>
  <fragen :post="fri" v-for="fri in friday" :key="fri.uid"></fragen>
  <h1 class="pad-day" v-if="this.$route.name !== 'english'">Samstag</h1>
  <h1 class="pad-day" v-else>Saturday</h1>
  <fragen :post="sat" v-for="sat in saturday" :key="sat.uid">
  </fragen>
</section>
</template>

<script>
import Fragen from '../components/Fragen.vue'

export default {
  name: 'programm',
  components: {
    Fragen
  },
  computed: {
    programm() {
      return this.$store.getters.getPageByUID('programm')
    },
    subpages() {
      return this.programm.children
    },
    friday() {
      let array = []
      for (var i = 0; i < this.subpages.length; i++) {
        var day = this.subpages[i].time
        var dayName = day.slice(8, 10)
        if (dayName === '24') {
          array.push(this.subpages[i])
        }
      }
      return array
    },
    saturday() {
      let array = []
      for (var i = 0; i < this.subpages.length; i++) {
        var day = this.subpages[i].time
        var dayName = day.slice(8, 10)
        if (dayName === '25') {
          array.push(this.subpages[i])
        }
      }
      return array
    },
    images() {
      return this.$store.getters.getPageByUID('home')
    }
  },
  data() {
    return {}
  },
  created() {
    window.addEventListener('scroll', this.inViewport)
  },
  destroyed() {
    window.removeEventListener('scroll', this.inViewport)
  },
  methods: {
    inViewport() {
      let hW = window.innerHeight / 2
      let center = window.scrollY + hW
      let top = this.$refs.section.offsetTop - 4
      let height = top + this.$refs.section.clientHeight + 4
      if (center > top && center < height) {
        this.$refs.fragen.classList.add('active')
      } else {
        this.$refs.fragen.classList.remove('active')
      }
    }
  },
  mounted() {
    this.$forceUpdate()
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.pad-day {
    padding-top: $gap * 4;
    margin-bottom: 0;
}
.pad-bottom {
    // margin-bottom: $gap * 4;
    // margin-bottom: 0;
}
.aha-row {
    padding: $gap / 2 0;
    border-bottom: 2px solid $font-color;
    @media only screen and (max-width: $phone) {
        border-bottom: 1px solid $font-color;
    }
    &.clickable {
        // cursor:pointer;
    }
    &.active {
        .aha-logo,
        .ahafrage {
            display: block;
        }
    }
    p {
        margin-bottom: 0;
    }
    .ahafrage {
        position: fixed;
        top: 0;
        left: 0;
        // top: 50%;
        // left: 4.2rem;
        // transform: translate(0, -50%);
        width: 50vw;
        height: 100vh;
        // background-image: url("../assets/images/Fragezeichen_2020_000.svg");
        // background-repeat: no-repeat;
        // background-position: center center;
        // background-size: contain;
        // background-clip: padding-box;
        z-index: 6;
        padding: $gap / 2;
        display: none;
    }
}
</style>
